<div *ngIf="hasAcces">
  <div class="widget-navigation">
    <a href="#information" class="scrollTo transition">Information
    </a>
    <a href="#status" class="scrollTo transition">Status
    </a>
    <a href="#security" class="scrollTo transition">Security
    </a>
    <a href="#getServedNetworkServers" class="scrollTo transition">Served NSs
    </a>
    <!--<a href="#alarms" class="scrollTo transition">Alarms</a>-->
    <a href="#getJoinServerLogs" class="scrollTo transition">Logs
    </a>
  </div>
  <form id="information" #validate="ngForm">
    <div class="widget-title margin-top-42"></div>
    <div class="widget width-49-perc margin-right-2-perc">
      <div class="widget-title">Join Server Info</div>
      <div class="info-content hide">
        <div class="widget-inner-title hide">VirtID:</div>
        <div class="widget-inner-content hide virtId">
          <input id="virtId" [value]="listInfo['virtId']" [disabled]="true" />
        </div>
      </div>
      <div class="info-content first-row">
        <div class="widget-inner-title">JoinEUI(s):
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['joinEUIs']}}" [disabled]="true" />

          <app-input-dynamic-list *ngIf="isAdmin" validationType="joinEUI" virtId="{{listInfo['virtId']}}"
            [inputValueSetter]="listInfo['joinEUIs']">
          </app-input-dynamic-list>
        </div>
      </div>
      <div class="info-content">
        <div class="widget-inner-title">Name:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['name']}}" [disabled]="true" />

          <app-input-edit *ngIf="isAdmin" validationType="name" formType="JS" saveType="name"
            virtId="{{listInfo['virtId']}}" inputValue="{{listInfo['name']}}">
          </app-input-edit>
        </div>
      </div>

      <!--JS URL Field-->
      <div class="info-content">
        <div class="widget-inner-title">JS URL:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['url_js']}}" [disabled]="true" />

          <app-input-edit *ngIf="isAdmin" validationType="url_js" saveType="url_js" virtId="{{listInfo['virtId']}}"
            inputValue="{{listInfo['url_js']}}">
          </app-input-edit>
        </div>
      </div>

      <!--JS Claim URL Field-->
      <div class="info-content">
        <div class="widget-inner-title">Claim URL:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['url_claim']}}" [disabled]="true" />

          <app-input-edit *ngIf="isAdmin" validationType="url_claim" saveType="url_claim"
            virtId="{{listInfo['virtId']}}" inputValue="{{listInfo['url_claim']}}">
          </app-input-edit>
        </div>
      </div>

      <!--PrimaryHub area-->
      <div class="info-content">
        <div class="widget-inner-title">Platform:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['platformId']}}" [disabled]="true" />

          <app-select-edit *ngIf="isAdmin" validationType="platform" virtId="{{listInfo['virtId']}}"
            inputValue="{{listInfo['platformId']}}">
          </app-select-edit>
        </div>
      </div>

      <!--Protocol Version area-->
      <div class="info-content">
        <div class="widget-inner-title">Protocol Version:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['protocolVersion']}}" [disabled]="true" />

          <app-protocol-edit *ngIf="isAdmin" virtId="{{listInfo['virtId']}}"
            saveType="NN" inputValue="{{listInfo['protocolVersion']}}">
          </app-protocol-edit>
        </div>
      </div>

      <!-- Http Mode area -->
      <div class="info-content">
        <div class="widget-inner-title">Http Mode:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['httpMode']}}" [disabled]="true" />

          <app-httpmode-edit *ngIf="isAdmin" virtId="{{listInfo['virtId']}}" inputValue="{{listInfo['httpMode']}}">
          </app-httpmode-edit>
        </div>
      </div>

      <div *ngIf="isAdmin" class="info-content last-row">
        <div class="widget-inner-title">Owner/Affiliation:
          <i class="fa fa-info-circle info-text"></i>
        </div>

        <div *ngIf="isAdmin" class="widget-inner-content">
          <app-edit-popover-button inputValue="{{strOwnership}}" ownerUname="{{listInfo['username']}}"
            ownerFname="{{ownerFname}}" ownerLname="{{ownerLname}}" ownerEmail="{{ownerEmail}}"
            virtId="{{listInfo['virtId']}}">
          </app-edit-popover-button>
        </div>

      </div>

      <div class="btn-area" [ngClass]="{'margin-top': !isAdmin}">
        <!--<button [routerLink]="['/edit-join-servers']" class="btn btn-outline-success my-2 my-sm-0 transition" type="submit">Edit</button>-->
        <button class="btn btn-outline-success my-2 my-sm-0 transition" [ngClass]="{'isDisabled' : !isAdmin}"
          [disabled]="!isAdmin" (click)="deleteModal.show()">Delete</button>
      </div>
      <app-delete-modal #deleteModal text="Join Server {{listInfo['name']}} will be deleted."
        server="{{listInfo['virtId']}}" deleteType="joinServerDetail"></app-delete-modal>
    </div>
    <div>
      <div id="status" class="widget width-49-perc">
        <div class="widget-title">Status
          <i class="text-tooltip"
             [ngClass]="(statusRefreshing)?'fa fa-spinner fa-spin':'fa fa-refresh'"
             aria-hidden="true"
             title-popup="Refresh"
             (click)="refreshStatus()">
          </i>
        </div>
        <div class="info-content first-row">
          <div class="widget-inner-title">Status:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input value="{{listStatus['status']}}" [disabled]="true" />
          </div>
        </div>
        <div class="info-content last-row">
          <div class="widget-inner-title">Message Count:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input value="{{listStatus['messageCount']}} {{listStatus['hasError']  ? '(!)' : '' }}" [disabled]="true" />
          </div>
        </div>
      </div>

      <div id="security" class="widget width-49-perc margin-top-42">
        <div class="widget-title">Security</div>

        <!--Security area-->
        <div class="info-content first-row last-row">
          <div class="widget-inner-title">Transport Security:
            <i class="fa fa-info-circle info-text"></i>
          </div>
          <div class="widget-inner-content">
            <input *ngIf="!isAdmin" value="{{listInfo['security']}}" [disabled]="true" />

            <app-security-edit *ngIf="isAdmin" virtId="{{listInfo['virtId']}}" inputValue="{{listInfo['security']}}">
            </app-security-edit>
          </div>
        </div>

        <div *ngIf="isAdmin" class="info-content last-row">
          <app-authtype-edit *ngIf="isAdmin" virtId="{{listInfo['virtId']}}" inputAuthType="{{listInfo['authType']}}"
                             inputAuthUsername="{{listInfo['authUsername']}}" inputAuthPassword="{{listInfo['authPassword']}}">
          </app-authtype-edit>
        </div>
      </div>
    </div>
  </form>

  <!-- Served Network Servers -->
  <app-served-network-servers virtId="{{listInfo['virtId']}}" name="{{listInfo['name']}}"
    joinEUIs="{{listInfo['joinEUIs']}}" (servedNetworkServersLoadedEvent)="servedNetworkServersLoaded($event)">
  </app-served-network-servers>

  <!-- Message Logs -->
  <app-message-logs virtId="{{listInfo['virtId']}}" [netIds]="listInfo['joinEUIs']" [getLogsUrl]="logsUrl">
  </app-message-logs>

</div>

<div *ngIf="!hasAcces">
  <h1>{{errorStatus}}:{{errorText}}</h1>
</div>
